import { useEffect } from "haunted";
import { PUB_SUBS } from "Services/pub-sub-service/PubSub";
import { useEffectWithCleanup, useState } from "Shared/haunted/CustomHooks";

let didScroll = false;
let navbarHeight = 0;
let lastScrollTop = 0;

export interface Props {
	navbarElement: HTMLDivElement;
	onScroll: () => void;
}

export const useHeaderScrollHandler = (props: Props) => {
	const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

	const handleScroll = () => {
		const st = window.scrollY;

		if (Math.abs(lastScrollTop - st) < 0) return;

		if (st > lastScrollTop && st > navbarHeight * 4) {
			setIsCollapsed(true);
		} else if (st < lastScrollTop && st >= navbarHeight * 4) {
			setIsCollapsed(false);
		} else if ((st < lastScrollTop && st < navbarHeight * 4) || st === 0) {
			setIsCollapsed(false);
		}

		lastScrollTop = st;
	};

	const init = () => {
		// https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c
		window.addEventListener(
			"scroll",
			() => {
				didScroll = true;
				props.onScroll();
			},
			false
		);

		window.setInterval(() => {
			if (didScroll) {
				handleScroll();
				didScroll = false;
			}
		}, 125);

		navbarHeight = props.navbarElement?.getBoundingClientRect().height || 0;

		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener("click", function (e) {
				e.preventDefault();
				window.setTimeout(() => setIsCollapsed(true), 1000);
				document.querySelector(anchor.getAttribute("href")).scrollIntoView({
					behavior: "smooth",
				});
			});
		});
	};

	useEffect(init, []);

	const subscribe = () => {
		const handler1 = PUB_SUBS.MobileSearchboxModalOpened.subscribe(() => setIsCollapsed(true));
		const handler2 = PUB_SUBS.MobileSearchboxModalClosed.subscribe(() => handleScroll());
		return () => {
			handler1.unsubscribe();
			handler2.unsubscribe();
		};
	};

	useEffectWithCleanup(subscribe, []);

	return { isCollapsed };
};
